module.exports = __webpack_public_path__ + "static/media/employee-section-transition.7fdb9da5.svg";